export default "__VITE_ASSET__B9XCg4Pj__"